/**
 * An error raised by a portal endpoint that answered with a non-2xx status.
 *
 * `/get-current-user` and `/save-user` read and write CloudInsurance on every
 * request, so they answer 502 when that system does not reply. The body of a
 * 502 is plain text, not JSON.
 */
export class ApiRequestError extends Error {
  constructor(
    public readonly endpoint: string,
    public readonly status: number | undefined,
    public readonly bodyText: string,
    cause?: unknown,
  ) {
    super(`${endpoint} failed with status ${status ?? 'unknown'}: ${bodyText}`);
    this.name = 'ApiRequestError';
    this.cause = cause;

    // `extends Error` breaks instanceof when the build targets ES5.
    Object.setPrototypeOf(this, ApiRequestError.prototype);
  }

  /** True when CloudInsurance could not be reached. The data was not saved. */
  get isUpstreamFailure(): boolean {
    return this.status === 502;
  }
}
